<template>
    <page>
        <module :title="title">
	        <c-form ref="editForm">
                <c-form-column>
                    <c-form-item type="textarea" label="福利描述" name="content" required></c-form-item>
                    <c-form-item type="image" label="福利图片" name="image" limit="99" required file-word="建议尺寸：1340×800px"></c-form-item>
                    <c-form-item type="textarea" label="福利待遇" name="benefit" required></c-form-item>
                </c-form-column>
            </c-form>
            <template slot="button">
                <c-button size="m" @click="save()">保存</c-button>
            </template>
        </module>
    </page>
</template>

<script>
    export default {
        name: 'm_recruit_benefit',

        props: {
            languageType: Number        //2=英文  1=中文
        },

        watch:{
            languageType(){
                this.title = (this.languageType==1?'中文':'英文')+'员工福利'
            }
        },

        data() {
            return {
                benefitList:[],
                title:'员工福利'
            }
        },

        mounted() {
	        this.getDetail();
        },

        methods: {
	        add(){
				this.benefitList.push({
                    title:''
				})
	        },

	        remove(index){
				if (this.benefitList && this.benefitList.length > 0)
		            this.benefitList.splice(index, 1);
	        },

            getDetail() {
                this.request({
                    url: this.languageType==2?'/website/recruit_en/benefit/detail':'/website/recruit/benefit/detail',
                    data: {},
                    loading: true,
                    success: data => {
                        if (data){
                            var formObj = JSON.parse(data);
                            this.$refs.editForm.set(formObj);
                        }
                    }
                });
            },

            save() {
                this.$refs.editForm.submit({
                    url: this.languageType==2?'/website/recruit_en/benefit/edit':'/website/recruit/benefit/edit',
                    rule: {
                        content:'请上输入福利描述',
                        image:'请上传福利图片',
                        benefit:'请输入各项福利信息'
                    },
                    dataFormatter: data => {
                        var submitObj = {};
                        submitObj.control_configure = JSON.stringify(data)
                        return submitObj;
                    },
                    success: () => {
                        this.$message({
                            text: '保存成功',
                            icon: 'success'
                        });
                    }
                });
            }
        }
    }
</script>

<style lang="stylus" scoped>
  .invoice-list {
    .item {
      box-sizing: border-box;
      width: 360px;
      height: 360px;
      padding: 10px 15px;
      margin-right: 26px;
      margin-bottom: 26px;
      background: #F9F9F9;

      p {
        padding: 5px 0;
        line-height: 20px;
        font-size: 13px;
        color: #333;
      }

      .handle {
        margin-top: 20px;
        text-align: right;

        a {
          margin-left: 15px;
          font-size: 16px;
          color: #666;
        }
      }
    }

    .add {
      box-sizing: border-box;
      width: 360px;
      height: 360px;
      border: 1px dashed #ddd;
      font-size: 50px;
      color: #ccc;
      cursor: pointer;

      &:hover {
        theme-border(main);
        theme-color(main);
      }
    }
  }
</style>